import { get } from './request'

export async function fetchSubscription() {
  const subscription = await get<any>('/subscription')
  return subscription
}
